import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const PercentageField = ({ value, onChange, ...props }) => {
	// Compute formatted display value similar to CurrencyField.
	const displayValue =
		value !== null && value !== undefined && value !== ""
			? Number(value).toLocaleString()
			: "";
	
	const handleChange = (event) => {
		let input = event.target.value;
		// Remove any % symbol and commas before validation
		const rawValue = input.replace(/[%\,]/g, '');
		// Allow only numbers with an optional decimal point (max 2 decimal places)
		if (/^\d*\.?\d{0,2}$/.test(rawValue)) {
			// Prevent values above 100
			if (rawValue && parseFloat(rawValue) > 100) return;
			if (onChange) {
				// Return numeric value while maintaining display formatting.
				onChange(rawValue !== "" ? parseFloat(rawValue) : null);
			}
		}
	};

	return (
		<TextField
		variant="filled"
			size='small'
			sx={{
				'& .MuiFilledInput-root': {
					backgroundColor: 'white !important'
				},
				'& input:focus': { border: 'none' },
				'& input': { border: 'none' },
				width: '100%',
			}}
			value={displayValue}
			onChange={handleChange}
			slotProps={{
				input: {
					endAdornment: (
						<InputAdornment position="end" sx={{ '& p': { m: 0 } }}>
							%
						</InputAdornment>
					)
				},
				htmlInput: { inputMode: 'decimal' },
				inputLabel: { shrink: false, sx: { transform: 'translate(12px, -6px) scale(0.75)' }},
			}}
			{...props}
		/>
	);
};

export default PercentageField;
